import api from './api';

export const ValidadeService = {
  async validade(code: string) {
    const { data } = await api.get(`/clients/validate-referral/${code}`);
    return data.data.valid;
  },
};
